<template>
    <v-dialog max-width="500px" v-model="inDialog" persistent>
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formCreateName)
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Mã kho')"
                                v-model.trim="item.categoryCode"
                                name="categoryCode"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('categoryCode')"
                                :data-vv-as="$t('Mã kho')"
                                disabled
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Tên kho')"
                                v-model.trim="item.categoryName"
                                name="categoryName"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('categoryName')"
                                :data-vv-as="$t('Tên kho')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="pondAreas"
                                :label="$t('Khu nuôi')"
                                v-model="item.parentId"
                                name="parentId"
                                item-value="categoryId"
                                item-text="categoryCode"
                                :data-vv-as="$t('Khu nuôi')"
                                v-validate="'required'"
                                :error-messages="errors.first('parentId')"
                                :disabled="item.categoryId ? true : false"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="areaStatus"
                                :label="$t('Trạng thái')"
                                v-model="item.status"
                                name="status"
                                item-value="value"
                                item-text="text"
                                :data-vv-as="$t('Trạng thái')"
                                :error-messages="errors.first('status')"
                            />
                        </v-flex>
                        <v-flex>
                            <v-checkbox
                                v-model="item.description"
                                label="Kho tài sản cố định"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.save") }}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { message } from "../../../services";
import axios from "axios";
import { areaContants } from "@/constants";

export default {
    name: "warehouse-create",
    components: { message, axios },
    props: {
        propsItem: {
            type: Object,
            default: () => {
                    return {}
                }
        },
        cDialog: {
            type: Boolean,
            default: false,
        },
        pondAreas: {
            type: Array,
            default: [],
        },
        formCreateName: {
            type: String,
            default: '',
        },
    },
    data: () => {
        return {
            areaStatus: areaContants.areaStatus,
            item: {
                categoryCode: "",
                categoryName: "",
                categoryTypeCode: "WAREHOUSE",
                status: 1,
                parentId: '',
                description: '',
            },
            inDialog: false,
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                // console.log(value);
                if (value !== null) {
                    this.item = {
                        categoryId: value.categoryId,
                        categoryCode: value.categoryCode
                            ? value.categoryCode
                            : "",
                        categoryName: value.categoryName
                            ? value.categoryName
                            : "",
                        parentId: value.parentId
                            ? value.parentId
                            : 0,
                        status: value.status ? value.status : 0,
                        description: value.description,
                    };
                } else {
                    this.resetFrom();
                }
            },
            deep: true,
        },
        cDialog(value) {
            this.inDialog = value;
        },
        inDialog (value) {
            if(!value){
                this.$emit("closeCreateDialog", "");
            }
        },
    },
    methods: {
        resetFrom: function () {
            this.emptyForm();
        },
        onCancel: function () {
            this.emptyForm();
            this.$emit("closeCreateDialog", "");
        },
        onSave: function () {
            // console.log(this.item);
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                if (this.item.description) {
                    this.item.description = 1;
                } else {
                    this.item.description = '';
                }

                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                            "/category/save?categoryTypeCode=WAREHOUSE",
                        this.item
                    )
                    .then(
                        (data) => {
                            console.log(data);
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.resetFrom();
                                this.onCancel();
                            } else {
                                let msg = data.description;
                                if (data.description === "lang.category.duplicateCode") {
                                    msg = 'Trùng mã kho vật tư';
                                } else if (data.description === "lang.category.duplicateName") {
                                    msg = 'Trùng tên kho vật tư';
                                }
                                message.error(this.$t(msg));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            });
        },
        emptyForm () {
            this.item = {
                categoryCode: "",
                categoryName: "",
                categoryTypeCode: "WAREHOUSE",
                status: 1,
                parentId: '',
                description: '',
            };
        },
    },
    created() {},
};
</script>
